const men = document.querySelector('#men_lab');
const men_chart = document.querySelector('#men_chart');
const women = document.querySelector('#women_lab');
const women_chart = document.querySelector('#women_chart');
const junior = document.querySelector('#junior_lab');
const junior_chart = document.querySelector('#junior_chart');
// modal
const sg_modals = document.querySelectorAll('#sizeguide-modal .size-table:not(:empty)');
const sg_modal = document.querySelector('#sizeguide-modal');
const sg_button = document.querySelector('#sizeguide_button_desk');
const sg_button_mob = document.querySelector('#sizeguide_button_mob')
const sg_close = document.querySelector('#sizeguide_close');
const sg_closes = document.querySelectorAll('#sizeguide_close');
const body_el = document.querySelector('body');

const sizes_title = document.querySelector('#sizes_title');
const measure_title = document.querySelector('#measure_title');

const size_chart = document.querySelector("#size_chart");
const measure_container = document.querySelector('#measure_container');
const gender_type = document.querySelector('#gender_type');
const gender_type_value = gender_type.getAttribute('data-current-gender');


const showhidePopupEl = (menuSelect, showEl, menuUnSelect,hideEl) => {
  menuSelect.classList.add("selected");
  showEl.classList.remove('hidden');
  menuUnSelect.classList.remove('selected');
  hideEl.classList.add("hidden");
}
const handleClick = (target, showSizeG, hide1SizeG, hide2SizeG)=>{
  showSizeG.style.display = "block";
  hide1SizeG.style.display = "none";
  hide2SizeG.style.display = "none";
}
if(gender_type_value == 'men' || gender_type_value == 'no-tag') {
  handleClick(men, men_chart, women_chart, junior_chart)
} else if(gender_type_value == 'wmn') {
    handleClick(women, women_chart, men_chart, junior_chart)
} else if (gender_type_value == 'jnr') {
  handleClick(junior, junior_chart, women_chart, men_chart)
}

men.addEventListener("click", ()=> {
  handleClick(men, men_chart, women_chart, junior_chart)
})
women.addEventListener("click", ()=> {
  handleClick(women, women_chart, men_chart, junior_chart)
})
junior.addEventListener("click", ()=> {
  handleClick(junior, junior_chart, women_chart, men_chart)
});
//open modal
sg_button.addEventListener("click", ()=> {
  if (sg_modals && sg_modals.length > 0) {
    sg_modals.forEach(sg_table => {
      const sg_modal = sg_table.closest('#sizeguide-modal');
      if (sg_modal) {
        sg_modal.classList.add('open');
      }
    });
  } else {
    const sg_modal = document.querySelector('#sizeguide-modal');
    if (sg_modal) {
      sg_modal.classList.add('open');
    }
  }
  body_el.style.overflow = 'hidden';
});

sg_button_mob.addEventListener("click", ()=> {
  if (sg_modals && sg_modals.length > 0) {
    sg_modals.forEach(sg_table => {
      const sg_modal = sg_table.closest('#sizeguide-modal');
      if (sg_modal) {
        sg_modal.classList.add('open');
      }
    });
  } else {
    const sg_modal = document.querySelector('#sizeguide-modal');
    if (sg_modal) {
      sg_modal.classList.add('open');
    }
  }
body_el.style.overflow = 'hidden';
});

sg_closes.forEach(sg_close => {
  sg_close.addEventListener("click", () => {
    const sg_modals = document.querySelectorAll('#sizeguide-modal');
    
    sg_modals.forEach(sg_modal => {
      sg_modal.classList.remove('open');
    });

    body_el.style.overflowY = 'scroll';
  });
});

sg_modal.addEventListener("click", (e)=> {
  if(e.target.classList.contains('sizeguide-popup-container')){
    sg_modal.classList.remove('open');
    body_el.style.overflowY = 'scroll';
  }
})
sg_modals.forEach(sg_table => {
  const sg_modal = sg_table.closest('#sizeguide-modal');
  console.log('sg_modal', sg_modal);
  
  sg_modal.addEventListener("click", (e) => {
    console.log(e.target);
    
    if(e.target.classList.contains('sizeguide-popup-container')){
      sg_modal.classList.remove('open');
      body_el.style.overflowY = 'scroll';
    }
  });
});

sizes_title.addEventListener("click", ()=> {
 showhidePopupEl(sizes_title, size_chart, measure_title, measure_container )
})
 measure_title.addEventListener("click", ()=> {
  showhidePopupEl(measure_title, measure_container,sizes_title, size_chart )
})
